import type { ExtensionApi } from './extension';
import { View } from './View';
import type { StandardChartView } from './MainStandardChartView';
import {
  type Spec as SimpleKLineSpec,
  layer as simpleKLine
} from '../layer/preset/hxKLine/simpleKLine';

export interface Spec {
  /** 图层，类似 echarts 中的 series 概念，但比 series 抽象程度更高 */
  layers: [SimpleKLineSpec];
}

export class SimpleKLineView extends View {
  private __destroyFunc!: () => void;

  klineIns!: {
    destroy: () => void;
  };

  render(
    api: ExtensionApi,
    $container: HTMLElement,
    spec: Spec,
    standardChartView: StandardChartView
  ) {
    if (spec.layers.length > 1) {
      throw new Error('Multiple `independent` layers are not supported.');
    }

    const layerSpec = spec.layers[0];

    this.__destroyFunc = simpleKLine.render(api, layerSpec, $container, standardChartView);
  }

  destroy() {
    this?.__destroyFunc?.();
  }
}
